import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutos por defecto
            gcTime: 1000 * 60 * 15, // 15 minutos de caché (antes cacheTime)
            retry: 1,
            refetchOnWindowFocus: true, // Útil para mantener datos frescos
            refetchOnReconnect: true,
        },
    },
})
